export default __webpack_public_path__ + "static/media/iconLightBall.88c9ced9.svg";